import React from "react";
import { bool, string, oneOf, elementType, oneOfType } from "prop-types";
import { classes } from "../utils/classes";
import forwardRefPropType from "../utils/forward-ref";
import pureFC from "../utils/pureFC";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";

const Button = ({
	Tag = "button",
	type = "button",
	styleType = "primary",
	isTheme = false,
	isOutline = false,
	isOutline2 = false,
	isBlock = false,
	isPreLine = false,
	size,
	disabled = false,
	className,
	forwardRef,
	spacing = { ...spacingProps },
	...props
}) => {
	const tabType = Tag !== "a" && { type };
	const themeClassName = !isTheme
		? [
				!isOutline && !isOutline2 && `btn-${styleType}`,
				isOutline && `btn-outline-${styleType}`,
				isOutline2 && `btn-outline2-${styleType}`,
		  ]
		: [];
	return (
		<Tag
			{...tabType}
			ref={forwardRef}
			className={classes(
				"btn",
				...themeClassName,
				isBlock && "btn-block",
				isPreLine && "btn--pre-line",
				size && `btn-${size}`,
				disabled && "disabled",
				...spacingClassName(spacing),
				className,
			)}
			{...props}
		/>
	);
};

Button.propTypes = {
	Tag: oneOfType([oneOf(["a", "button"]), elementType]),
	type: oneOf(["button", "submit", "reset"]),
	styleType: oneOf([
		"primary",
		"secondary",
		"success",
		"danger",
		"warning",
		"info",
		"gray",
		"dark",
		"light",
		"info-light",
		"link",
		"copy",
		"input-group",
	]),
	isTheme: bool,
	isOutline: bool,
	isOutline2: bool,
	isBlock: bool,
	isPreLine: bool,
	disabled: bool,
	size: oneOf(["xs", "s", "m", "l"]),
	className: string,
	forwardRef: forwardRefPropType,
	focus: bool,
	spacing: spacingPropTypes,
};

const ButtonLink = props => <Button Tag="a" {...props} />;

Button.Link = ButtonLink;

export default pureFC(Button);
